import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { HttpServiceProvider } from '../../providers/http-service/http-service';
import { GlobalServiceProvider } from '../../providers/global-service/global-service';
import { MessageServiceProvider } from '../../providers/message-service/message-service';
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  loading = true;
  spinning = false;
  loginForm: FormGroup;
  version = GlobalServiceProvider.Version;
  constructor(public navCtrl: NavController, public navParams: NavParams, public afAuth: AngularFireAuth, public httpService: HttpServiceProvider, public formBuilder: FormBuilder, public db: AngularFireDatabase, public messageService: MessageServiceProvider) {
    this.setupForm();
    this.loadSession();
  }
  setupForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required])],
      password: ['', Validators.compose([Validators.required])]
    });
  }
  loadSession() {
    this.spinning = true;
    const authObserver = this.afAuth.authState.subscribe(user => {
      if (user) {
        console.log(user.displayName);

        GlobalServiceProvider.FirebaseUser = user;
        user.getIdToken().then(e => { console.log(e); GlobalServiceProvider.Token = e; this.loadUserInfo(); })

        authObserver.unsubscribe();
      } else {
        this.loading = false;
        this.spinning = false;
        //LOADING DONE
        authObserver.unsubscribe();
      }
    });
  }
  loadUserInfo()
  {
    var that = this;
    console.log("LOADUSERINFO", GlobalServiceProvider.UserInfo);
    if (GlobalServiceProvider.UserInfo == null) {
      this.httpService.call("userinfo/Load.php", { uid: GlobalServiceProvider.FirebaseUser.uid, email: GlobalServiceProvider.FirebaseUser.email, displayname: GlobalServiceProvider.FirebaseUser.displayName }).then(result => {
        this.spinning = false;
        if (result.success) {
          console.log(GlobalServiceProvider.VerifiedUser);
          GlobalServiceProvider.UserInfo = result.data.userinfo;
          if (GlobalServiceProvider.VerifiedUser) {
            this.navCtrl.setRoot("HomePage");
          }
          else {
            //this.promptInviteKey();
            this.navCtrl.setRoot("InvitekeyPage");
          }

        }
        else {

          this.messageService.alert("Error 😖", result.message, function () { that.resetLogin(); });
        }

      }).catch(error => {
        console.log(error);
        this.messageService.alert("Error1 😖", error.message, function () { that.resetLogin(); });
      });
    }
    else {
      if (GlobalServiceProvider.VerifiedUser) {
        this.navCtrl.setRoot("HomePage");
      }
      else {
        this.navCtrl.setRoot("InvitekeyPage");
      }
    }
  }

  resetLogin() {
    this.afAuth.auth.signOut().then(() => {

      GlobalServiceProvider.FirebaseUser = null;
      GlobalServiceProvider.UserInfo = null;
      GlobalServiceProvider.Token = null;
      GlobalServiceProvider.Games = [];
      GlobalServiceProvider.GamesLoaded = false;

      this.loading = false;
    });
  }

  login() {
    if (!this.loginForm.valid) {
      if (!this.loginForm.controls.email.valid) {
        this.messageService.alert("Error 🙁", "Please fill in a valid email");
      }
      else {
        if (!this.loginForm.controls.password.valid) {
          this.messageService.alert("Error 🙁", "Please fill in a valid password");
        }
      }
    } else {

      this.messageService.showLoading("Logging you in");
      this.afAuth.auth.signInWithEmailAndPassword(this.loginForm.controls.email.value, this.loginForm.controls.password.value).then((e) => {
        this.messageService.hideLoading();
        //this.navCtrl.setRoot(LoadingPage);
        this.loadSession();
      }, error => {
        this.messageService.hideLoading();
        this.processErrorMessage(error);
      });
    }
  }
  processErrorMessage(error) {
    console.log(error);
    this.messageService.alert("Error 😖", "Email / Password combination incorrect");
  }
  gotoRegister() {
    this.navCtrl.push("RegisterPage");
  }
  gotoForgotPassword() {
    this.navCtrl.push("ForgotPage");
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts